import gvl, { listPurposes } from '@module/consent-manager/gvl';
import tcModel from '@module/consent-manager/tc-model';
import { PurposeIds } from '@module/consent-manager/config';

interface VendorConsent {
  id: number;
  name: string;
  purposeConsent: boolean;
  purposeDescriptions: Array<string>;
  featureDescriptions: Array<string>;
  policyUrl: string;
  descriptionVisible: boolean;
}

interface State<T> {
  [key: number]: T;
}

//TODO: type the consentLanguage
export function initVendorListState(
  consentLanguage: any
): State<VendorConsent> {
  const v = {} as State<VendorConsent>;

  for (const vendorId in gvl.vendors) {
    const { name, purposes, features } = gvl.vendors[vendorId];

    let { policyUrl } = gvl.vendors[vendorId];

    if (!/^https?:\/\//i.test(policyUrl)) {
      policyUrl = 'https://' + policyUrl;
    }

    const purposeDescriptions: Array<string> = purposes.map(
      (id) => consentLanguage.purposes[id]?.description
    );

    const featureDescriptions: Array<string> = features.map(
      (id) => consentLanguage.features[id]?.description
    );

    const id = parseInt(vendorId);

    v[vendorId] = {
      id,
      name,
      purposeDescriptions,
      featureDescriptions,
      policyUrl,
      purposeConsent: tcModel.vendorConsents.has(id),
      descriptionVisible: false,
    } as VendorConsent;
  }

  return v;
}

interface Purpose {
  id: number;
  name: string;
  description: string;
  descriptionLegal: string;
  purposeConsent: boolean;
  purposeLegitimateInterest: boolean;
  descriptionVisible: boolean;
  purposeConsentVisible: boolean;
}

//TODO: type the consentLanguage
export function initPurposeListState(consentLanguage: any): State<Purpose> {
  const v = {} as State<Purpose>;
  const purposes = listPurposes();

  for (const purposeId in purposes) {
    const { name, description, descriptionLegal } = consentLanguage.purposes[
      purposeId
    ];

    const id = parseInt(purposeId);
    let purposeConsentVisible = true;

    if (id === PurposeIds.DEVELOP_IMPROVE_PRODUCTS) {
      purposeConsentVisible = false;
    }

    v[id] = {
      id,
      name,
      description,
      descriptionLegal,
      purposeConsent: tcModel.purposeConsents.has(id),
      purposeLegitimateInterest: tcModel.purposeLegitimateInterests.has(id),
      descriptionVisible: false,
      purposeConsentVisible,
    } as Purpose;
  }

  return v;
}
